// Generated from Func.g4 by ANTLR 4.5.1
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete listener for a parse tree produced by FuncParser.
function FuncListener() {
  antlr4.tree.ParseTreeListener.call(this);
  return this;
}

FuncListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
FuncListener.prototype.constructor = FuncListener;

// Enter a parse tree produced by FuncParser#func.
FuncListener.prototype.enterFunc = function (ctx) {};

// Exit a parse tree produced by FuncParser#func.
FuncListener.prototype.exitFunc = function (ctx) {};

// Enter a parse tree produced by FuncParser#array.
FuncListener.prototype.enterArray = function (ctx) {};

// Exit a parse tree produced by FuncParser#array.
FuncListener.prototype.exitArray = function (ctx) {};

// Enter a parse tree produced by FuncParser#atom.
FuncListener.prototype.enterAtom = function (ctx) {};

// Exit a parse tree produced by FuncParser#atom.
FuncListener.prototype.exitAtom = function (ctx) {};

// Enter a parse tree produced by FuncParser#params.
FuncListener.prototype.enterParams = function (ctx) {};

// Exit a parse tree produced by FuncParser#params.
FuncListener.prototype.exitParams = function (ctx) {};

// Enter a parse tree produced by FuncParser#pathref.
FuncListener.prototype.enterPathref = function (ctx) {};

// Exit a parse tree produced by FuncParser#pathref.
FuncListener.prototype.exitPathref = function (ctx) {};

// Enter a parse tree produced by FuncParser#contextref.
FuncListener.prototype.enterContextref = function (ctx) {};

// Exit a parse tree produced by FuncParser#contextref.
FuncListener.prototype.exitContextref = function (ctx) {};

// Enter a parse tree produced by FuncParser#string.
FuncListener.prototype.enterString = function (ctx) {};

// Exit a parse tree produced by FuncParser#string.
FuncListener.prototype.exitString = function (ctx) {};

// Enter a parse tree produced by FuncParser#literal.
FuncListener.prototype.enterLiteral = function (ctx) {};

// Exit a parse tree produced by FuncParser#literal.
FuncListener.prototype.exitLiteral = function (ctx) {};

// Enter a parse tree produced by FuncParser#number.
FuncListener.prototype.enterNumber = function (ctx) {};

// Exit a parse tree produced by FuncParser#number.
FuncListener.prototype.exitNumber = function (ctx) {};

// Enter a parse tree produced by FuncParser#variable.
FuncListener.prototype.enterVariable = function (ctx) {};

// Exit a parse tree produced by FuncParser#variable.
FuncListener.prototype.exitVariable = function (ctx) {};

exports.FuncListener = FuncListener;
